/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Featuremultisubjecttitle3Inputs */

const zh_about_featuremultisubjecttitle3 = /** @type {(inputs: About_Featuremultisubjecttitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全学科覆盖`)
};

const en_about_featuremultisubjecttitle3 = /** @type {(inputs: About_Featuremultisubjecttitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full Subject Coverage`)
};

const es_about_featuremultisubjecttitle3 = /** @type {(inputs: About_Featuremultisubjecttitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobertura de todas las materias`)
};

/**
* | output |
* | --- |
* | "Full Subject Coverage" |
*
* @param {About_Featuremultisubjecttitle3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const about_featuremultisubjecttitle3 = /** @type {((inputs?: About_Featuremultisubjecttitle3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Featuremultisubjecttitle3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_about_featuremultisubjecttitle3(inputs)
	if (locale === "en") return en_about_featuremultisubjecttitle3(inputs)
	return es_about_featuremultisubjecttitle3(inputs)
});
export { about_featuremultisubjecttitle3 as "about_featureMultiSubjectTitle" }